export default __webpack_public_path__ + "static/it-d85ad617af6f3281c93a79757be492ca.svg";